define(["utils/findElements"],
	function(findElements) {      
        var codeEval = function(options, callback){
            var code = options.code;
            if (options.triggeringEvent){ 
                if (options.triggeringEvent.key){
                    code = code.split('{{triggeringEvent.key}}').join(options.triggeringEvent.key);
                }
                if (options.triggeringEvent.value){
                    code = code.split('{{triggeringEvent.value}}').join(options.triggeringEvent.value);
                }
            }
            try{
                eval(code);
                callback(null);
            }   
            catch(e){
                callback(e);
            } 
        };
		return codeEval;
	}
);



//////////////////
// WEBPACK FOOTER
// ./responses/tags/codeEval/codeEval.js
// module id = 3
// module chunks = 0